const MessageConstant = {
  sucesso: {
    criar: 'Item criado com sucesso!',
    atualizar: 'Item atualizado com sucesso!',
    deletar: 'Item deletado com sucesso!',
  },
  erro: {
    criar: 'Erro ao criar.',
    atualizar: 'Erro ao atualizar.',
    deletar: 'Erro ao deletar.',
    naoEncontrado: 'Item não encontrado.',
    generico: 'Ocorreu um erro. Por favor, tente novamente mais tarde.',
  },
  validacao: {
    campoObrigatorio: 'Este campo é obrigatório.',
  },
};

export default MessageConstant;
